// extracted by mini-css-extract-plugin
export default {"widget_container":"styled_widget_container__63WLH"};